import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeploymentService } from 'src/app/core/services/deployment.service';

@Component({
  selector: 'app-delete-deployment',
  templateUrl: './delete-deployment.component.html',
  styleUrls: ['./delete-deployment.component.scss']
})
export class DeleteDeploymentComponent implements OnInit {

  constructor(private depService: DeploymentService,
    public dialogRef: MatDialogRef<DeleteDeploymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { name: string, type: string},
    private snackBar: MatSnackBar
    ) { }

  name: string = this.data.name;
  type: string = this.data.type;
  inpVal: string = "";
  skipCloud: boolean = true;

  ngOnInit(): void {
  }

  onCancel(){
    this.dialogRef.close(false)
  }

  onSubmit() {
    const returnObject = { skipCloud: this.skipCloud };
    this.dialogRef.close({ returnObject })
    this.snackBar.open("Deletion in progress.", "Ok", {
      duration: 5000
    })
  }

}
